module.exports = __webpack_public_path__ + "img/entrance_plant_4.170497a8.jpg";